export default __webpack_public_path__ + "static/media/graph-mobile.png";